import React, {useEffect, useRef, useState} from 'react';

/**
 * Counts up from the previous value to the new one. Replaces the unmaintained
 * react-animate-numbers (incompatible with React 19). Styling is inherited from
 * the parent, so callers control font/size/color via className as before.
 */
const AnimatedNumber = ({value, durationMs = 600}) => {
  const [display, setDisplay] = useState(value);
  const fromRef = useRef(value);
  const rafRef = useRef(null);

  useEffect(() => {
    const from = fromRef.current;
    const to = value;
    if (from === to) return undefined;

    const start = performance.now();
    const tick = (now) => {
      const t = Math.min((now - start) / durationMs, 1);
      const eased = 1 - (1 - t) ** 3; // easeOutCubic
      setDisplay(Math.round(from + (to - from) * eased));
      if (t < 1) {
        rafRef.current = requestAnimationFrame(tick);
      } else {
        fromRef.current = to;
      }
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [value, durationMs]);

  return <span className="tabular-nums">{display.toLocaleString('en-US')}</span>;
};

export default AnimatedNumber;
